import {
  compareStrings,
  displayTranslations,
  getArtwork,
  parseCategoryName,
  parseLanguage,
  titleize
} from "../../utils/utils";
import GameNameParser from "./GameNameParser";
import React, { useState } from "react";
import ExpansionIcon from "./ExpansionIcon";
import I18n from "i18n-js";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";


export const BlueprintImageAccordionTitleImage = ({
  blueprintImage,
  handleShowLargeImage
}) => {


  return(
    <div className="col-3 col-md-2 p-0 text-center">
      <ShowBlueprintImageFrontImage
        size={"thumb"}
        blueprintImage={blueprintImage}
        handleShowLargeImage={handleShowLargeImage}
        additionalClasses={blueprintImage.is_graded_image ? (blueprintImage.blueprint?.category?.name?.toLowerCase() === 'booster pack' ? "thumb-image-graded-booster-pack m-auto" : "thumb-image-graded-card m-auto") : ''}
      />
    </div>
  )
}


export const BlueprintImageAccordionTitleName = ({
    blueprintImage
  }) => {

  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)

  return(

    <div className="col-6">
      {
        blueprintImageNames.length > 1 ?
          <React.Fragment>
            <p className="mb-0">
              { blueprintImageNames[0] }
            </p>
            <p className="text--size-small">
              ({ blueprintImageNames[1] })
            </p>
          </React.Fragment>
          :
          <p>
            { blueprintImageNames[0] }
          </p>
      }

      {
        blueprintImage.collector_number &&
        <p>{blueprintImage.collector_number}</p>
      }

      {
        getArtwork(blueprintImage) &&
        <p><small>[{getArtwork(blueprintImage)}]</small></p>
      }
    </div>
  )
}


export const BlueprintImageAccordionTitleIcon = ({
    blueprintImage
  }) => {

  return(
    <React.Fragment>
      {
        blueprintImage.expansion?.icon_url &&
        <div className="mb-2"
             key={blueprintImage.expansion.icon_url}>
          <ExpansionIcon
            icon_url={blueprintImage.expansion.icon_url}
            width={"40px"}
          />
        </div>
      }
    </React.Fragment>
  )
}



const  BlueprintImageAccordionTitle = ({
    blueprintImage,
    handleShowLargeImage,
    hideImage
  }) => {

  return (
    <React.Fragment>
      {
        !hideImage &&
          <BlueprintImageAccordionTitleImage
            blueprintImage={blueprintImage}
            handleShowLargeImage={handleShowLargeImage}
          />
      }

      <BlueprintImageAccordionTitleName
        blueprintImage={blueprintImage}
      />

      <div className="col-3 d-block align-items-center text-center p-0">
        <BlueprintImageAccordionTitleIcon
          blueprintImage={blueprintImage}
        />
      </div>
    </React.Fragment>
  );
}

export default  BlueprintImageAccordionTitle;
